<template>
  <div class="flight-deals__filter">
    <div
      class="flight-deals__filter-header layout-row"
      v-if="!isLessThanDesktop"
    >
      <p class="heading-h3">Filters</p>
      <button
        type="button"
        class="button button--text"
        @click="resetFiltersHandler"
      >
        Reset
      </button>
    </div>
    <div class="deals-filters__mobile-header">
      <airport-lookup
        from-airport-label="Travel from?"
        :show-to="false"
        :airport-from="filterState?.from"
        :show-code="false"
        @update:airportFrom="
          (v) => {
            filterUpdateHandler({ value: v, key: 'from' });
          }
        "
      ></airport-lookup>
      <button
        role="button"
        aria-label="mobile filter toggle"
        class="button button--outlined deals-filters__filter-button"
        @click="
          () => {
            openSheetHandler();
          }
        "
      >
        <i
          class="icon icon-filter icon-color--red icon--xs"
          aria-hidden="true"
        ></i>
        <span>Filter</span>
      </button>
    </div>
    <vue-bottom-sheet
      v-if="isLessThanDesktop"
      ref="filtersheet"
      max-width="1200px"
    >
      <slot
        name="filtercontent"
        :resetFiltersHandler="resetFiltersHandler"
        :filterUpdateHandler="filterUpdateHandler"
        :filterState="filterState"
        :fromKey="fromKey"
        :monthKey="monthKey"
        :fareKey="fareKey"
        :openSheetHandler="openSheetHandler"
        :closeSheetHandler="closeSheetHandler"
      ></slot>
    </vue-bottom-sheet>
    <slot
      name="filtercontent"
      v-if="!isLessThanDesktop"
      :resetFiltersHandler="resetFiltersHandler"
      :filterUpdateHandler="filterUpdateHandler"
      :filterState="filterState"
      :fromKey="fromKey"
      :monthKey="monthKey"
      :fareKey="fareKey"
    ></slot>

    <div class="deals-disclaimer" v-if="!isLessThanDesktop">
      <slot name="dealsdisclaimerblock"></slot>
    </div>
  </div>
</template>

<script setup>
import { ref, inject, watch } from 'vue';
import { VueBottomSheet } from '@webzlodimir/vue-bottom-sheet';
import '@webzlodimir/vue-bottom-sheet/dist/style.css';
import { useIsBreakpointSize } from '../../hooks/useIsMobile';
import AirportLookup from '../AirportLookup/AirportLookup.vue';
const filterState = ref({
  from: { locIATA: '', locCity: '' },
  month: {
    minValue: null,
    maxValue: null,
  },
  fare: {
    minValue: null,
    maxValue: null,
  },
  region: [],
  activities: [],
});

const fromKey = ref(Math.random().toString(36).substring(2, 12));
const monthKey = ref(Math.random().toString(36).substring(2, 12));
const fareKey = ref(Math.random().toString(36).substring(2, 12));
const filtersheet = ref(null);
const isLessThanDesktop = useIsBreakpointSize(991);

const props = defineProps({
  initialValues: {
    type: Object,
    default: () => {
      return {};
    },
  },
  injectedFilterState: {
    type: String,
    default: 'injectedFilterState',
  },
});

const injectedState = inject(props.injectedFilterState);

watch(
  () => injectedState?.value,
  () => {
    filterState.value = { ...injectedState.value };
  },
);

const emitHandler = (name, e) => {
  emit(name, e);
};

const resetFiltersHandler = () => {
  filterState.value = {
    from: '',
    month: {
      minValue: 0,
      maxValue: 11,
    },
    fare: {
      minValue: null,
      maxValue: null,
    },
    region: [],
    activities: [],
  };
  fromKey.value = Math.random().toString(36).substring(2, 12);
  monthKey.value = Math.random().toString(36).substring(2, 12);
  fareKey.value = Math.random().toString(36).substring(2, 12);
  emitHandler('filter-change', { ...filterState.value });
};

const filterUpdateHandler = (v) => {
  const { key } = v;

  let value = { ...filterState.value };

  switch (key) {
    case 'from':
      value.from = { locIATA: v.value.locIATA, locCity: v.value.locCity };
      break;
    case 'month':
      value.month = { ...v.value };
      break;
    case 'fare':
      value.fare = { ...v.value };
      break;
    case 'region':
      const regionName = v.name.toLowerCase();
      if (!value.hasOwnProperty('region')) {
        value.region = [regionName];
      } else if (v.value && !value?.region?.includes(regionName)) {
        value.region.push(regionName);
      } else if (!v.value && value?.region?.includes(regionName)) {
        const indexOf = value.region.indexOf(regionName);
        value.region.splice(indexOf, 1);
      }
      break;
    case 'activities':
      const activitiesName = v.name.toLowerCase();
      if (!value.hasOwnProperty('activities')) {
        value.activities = [activitiesName];
      } else if (v.value && !value?.activities?.includes(activitiesName)) {
        value.activities.push(activitiesName);
      } else if (!v.value && value?.activities?.includes(activitiesName)) {
        const indexOf = value.activities.indexOf(activitiesName);
        value.activities.splice(indexOf, 1);
      }
      break;

    default:
      break;
  }
  filterState.value = { ...value };
  emitHandler('filter-change', { ...value });
};

const emit = defineEmits(['filter-change']);

const openSheetHandler = () => {
  filtersheet.value.open();
};

const closeSheetHandler = () => {
  filtersheet.value?.close();
};
</script>
